export type UploadStatus =
  | 'PENDING'
  | 'UPLOADING'
  | 'ANALYZING'
  | 'ANALYZE_UNAVAILABLE'
  | 'TERMINATED'
  | 'FAILURE';

/** Analysis terminal outcome (excludes upload FAILURE). */
export type TerminalImportStatus = Extract<UploadStatus, 'TERMINATED' | 'ANALYZE_UNAVAILABLE'>;

export const TERMINAL_UPLOAD_STATUSES = new Set<UploadStatus>([
  'TERMINATED',
  'ANALYZE_UNAVAILABLE',
  'FAILURE',
]);

export function isTerminalUploadStatus(status: UploadStatus): boolean {
  return TERMINAL_UPLOAD_STATUSES.has(status);
}
